// V2 Mods section config — the page the "/mods/v2" tab embeds.
//
// There is NO new app and NO new token handshake here. Mods is a page inside the HotUtilsV2-Player app
// (mod-system-v2.md §4.6: "a Mods tab that embeds this app at /mods — no new app, no new token; the Player
// app's parent token already pins playerId"), exactly as V2-Datacrons and V2-Player Events are. So this
// module only names the URL; the origin, the enablement gate and the parent-token minting all come from
// utils/v2player.ts unchanged — the same division of labour utils/v2compares.ts uses.
//
// ⚠️ This tab is ADDITIVE. The legacy Mods suite (14 routes under /mods/*) stays exactly where it is for the
// whole migration; nothing here replaces or hides it.

import { getV2PlayerUrl, isV2PlayerEnabled } from "./v2player";

/**
 * The Player app's Mods page.
 *
 * 🔴 The path is the whole contract with the embedded app: `App.tsx` there selects the page with
 * `pathname.startsWith('/mods')` and FALLS THROUGH TO DATACRONS otherwise. A wrong or dropped path does not
 * fail loudly — the app boots and shows Datacrons, so the tab looks like it simply does not work yet. That
 * is what the test on this function pins.
 *
 * One URL, no sub-paths: the Loadouts / Locker split is in-page tabs inside the app's `ModsPage`, not app
 * navigation (§4.6), so the parent needs exactly one iframe src.
 */
export function getV2ModsUrl(): string {
  return getV2PlayerUrl() + "/mods";
}

/**
 * The V2-Mods tab has no gate of its own: it IS the Player app, so it appears exactly where V2-Datacrons and
 * V2-Player Events do — development.hotutils.com and localhost today. Named separately rather than calling
 * isV2PlayerEnabled() at the call sites so the section's gate is one thing to change on the day Mods
 * graduates ahead of (or behind) the rest of that app.
 *
 * The ROUTE and the MENU ITEM must both use this, or the tab appears where it cannot work.
 */
export function isV2ModsEnabled(): boolean {
  return isV2PlayerEnabled();
}
